import { inject } from '@angular/core';
import { Actions, OnInitEffects, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, of, switchMap } from 'rxjs';
import { I18nActions } from './i18n.actions';

export class I18nEffects implements OnInitEffects {
  private readonly actions$ = inject(Actions);
  private readonly translateService = inject(TranslateService);

  readonly setLocale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(I18nActions.setLocale),
      switchMap(({ locale }) =>
        this.translateService.use(locale).pipe(
          map(() => I18nActions.setLocaleSuccess({ locale })),
          catchError(() =>
            of(I18nActions.setLocaleFailure({ error: `No se pudo cargar el idioma: ${locale}` })),
          ),
        ),
      ),
    ),
  );

  ngrxOnInitEffects() {
    return I18nActions.setLocale({ locale: 'es' });
  }
}
